var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtpScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 515.61,
    height: 290.587,
    viewBox: "0 0 515.61 290.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.167,
    x2: 1.07,
    y2: 1.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#ffbe69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.136,
    y1: 0.167,
    x2: 1.07,
    y2: 1.021,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.061,
    y1: 0.367,
    x2: 1.094,
    y2: 1.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42d40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e85467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01c30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4e6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#469dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234f80"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8770",
    "data-name": "Group 8770",
    transform: "translate(-524.914 -103.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(-710.393 28.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M140.078,384.048a10.674,10.674,0,0,0-4.843,8.392c.009,3.084,2.191,4.327,4.874,2.778a10.675,10.675,0,0,0,4.846-8.39C144.947,383.74,142.765,382.5,140.078,384.048Zm-.028-10.125c-8.611,4.971-12.621,14.072-12.785,14.457-.461,1.063-.27,2.034.424,2.169a1.239,1.239,0,0,0,.845-.191,3.255,3.255,0,0,0,1.258-1.493,27.216,27.216,0,0,1,10.268-11.45c6.875-3.97,9.824-.128,9.944.03.283.4.792.414,1.317.112a2.771,2.771,0,0,0,.76-.674,2.544,2.544,0,0,0,.547-2.7C152.471,373.96,148.725,368.914,140.049,373.923Zm28-32.107c-.342-.477-8.592-11.589-27.888-.448-19.231,11.1-28.093,31.213-28.46,32.066-.464,1.069-.273,2.039.424,2.173a1.25,1.25,0,0,0,.845-.192,3.26,3.26,0,0,0,1.261-1.5c.081-.188,8.393-18.925,25.94-29.057,17.49-10.1,24.949-.2,25.255.229.283.4.8.412,1.317.112a2.788,2.788,0,0,0,.76-.677A2.542,2.542,0,0,0,168.053,341.816Z",
    transform: "translate(1240.537 -260.852)",
    fill: "#c4d9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M158.151,404.535c-12.569,7.257-18.384,20.458-18.625,21.014-.464,1.069-.273,2.039.424,2.173a1.244,1.244,0,0,0,.845-.192,3.266,3.266,0,0,0,1.261-1.5c.206-.477,5.216-11.722,16.105-18.009,10.828-6.252,15.458-.155,15.647.1.283.4.792.415,1.317.112a2.771,2.771,0,0,0,.76-.674,2.545,2.545,0,0,0,.547-2.7c-.224-.317-5.65-7.62-18.281-.328Z",
    transform: "translate(1222.48 -302.962)",
    fill: "#c4d9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M150.274,177.02c-15.486,8.941-22.635,25.166-22.93,25.851-.464,1.069-.273,2.039.424,2.173a1.251,1.251,0,0,0,.845-.192,3.262,3.262,0,0,0,1.26-1.5c.264-.6,6.6-14.871,20.41-22.842,13.741-7.933,19.609-.174,19.85.16.283.4.792.415,1.317.112a2.777,2.777,0,0,0,.76-.674,2.55,2.55,0,0,0,.547-2.707c-.276-.385-6.939-9.354-22.483-.38Z",
    transform: "translate(1230.387 -85.795)",
    fill: "#c4d9f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M884.223,304.091l.315-.315a.183.183,0,1,0-.259-.259l-.315.315-.315-.315a.183.183,0,0,0-.259.259l.315.315-.315.315a.183.183,0,0,0,.259.259l.315-.315.315.315a.183.183,0,1,0,.259-.259l-.315-.315Z",
    transform: "translate(141.24 -68.381)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M999.347,144.656a.72.72,0,1,1,.72-.72A.721.721,0,0,1,999.347,144.656Zm0-1.215a.495.495,0,1,0,.495.495A.5.5,0,0,0,999.347,143.441Z",
    transform: "translate(40.457 71.702)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M294.484,563.586l9.3-9.3a5.4,5.4,0,1,0-7.64-7.644l-9.3,9.3-9.3-9.3a5.4,5.4,0,1,0-7.641,7.644l9.3,9.3-9.28,9.28a5.405,5.405,0,0,0,7.644,7.644l9.281-9.281,9.28,9.281a5.405,5.405,0,1,0,7.645-7.644Z",
    transform: "translate(623.633 -240.458)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1217,470.861a5.64,5.64,0,0,1-3.234,8.359l-18.887,5.508a5.636,5.636,0,0,1-7.052-6.751l4.673-19.108a5.637,5.637,0,0,1,9.373-2.733l14.21,13.6A5.635,5.635,0,0,1,1217,470.861Zm-24.718,9.074a1.173,1.173,0,0,0,1.356.527l18.89-5.508a1.157,1.157,0,0,0,.821-.863,1.171,1.171,0,0,0-.332-1.145l-14.21-13.6a1.194,1.194,0,0,0-1.986.58l-4.673,19.107a1.148,1.148,0,0,0,.138.9Z",
    transform: "translate(-662.744 -161.839)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M73.2,414.932a13,13,0,1,1,13-13,13.015,13.015,0,0,1-13,13Zm0-21.93a8.931,8.931,0,1,0,8.931,8.931A8.942,8.942,0,0,0,73.2,393Z",
    transform: "translate(771.8 -227.846)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8747",
    "data-name": "Group 8747",
    transform: "translate(-21.07 30.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632",
    transform: "translate(703.362 279.829)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 37.514,
    cy: 8.864,
    rx: 37.514,
    ry: 8.864,
    transform: "translate(0 66.857)",
    fill: "#dde1f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(8.875 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M722.73,795.11s-11.977,1.772-11.772,1.653,21.92,11.019,21.92,11.019l21.4-9.587-10.609-3.084Z",
    transform: "translate(-703.78 -739.708)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M721.23,813.778l-.179,0h-.111c-3.047.035-5.037-.041-5.037-.041s-.146.033-.413.088c-2.605.54-16.651,3.216-15.454-2.076,1.049-4.648,9.476-4.07,12.856-3.643a.146.146,0,0,1,.033,0c.843.108,1.363.2,1.363.2s1.677-.721,4.323-1.748c.109-.043.221-.088.332-.131,8.718-3.383,27.052-9.8,31.8-5.943v0c.052.04.1.084.152.13,0,0,.008,0,.009.007.05.048.1.1.146.146a1.077,1.077,0,0,1,.119.135.4.4,0,0,1,.044.051,3.049,3.049,0,0,1,.293.443,2.416,2.416,0,0,1,.111.236,2.928,2.928,0,0,1,.179.556c.043.2.078.393.1.585a5.719,5.719,0,0,1,.046,1c-.381,8.547-20.778,9.858-30.711,9.99Z",
    transform: "translate(-697.68 -742.033)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M744.235,814.54l-.337-.994-.146-.433a.006.006,0,0,1,0-.005l-2.291-6.774-.329-.971c8.726-3.387,27.628-9.129,32.456-5.11l0,0a1.613,1.613,0,0,1,.153.138s.008,0,.009.007c.05.048.1.1.146.146a1.069,1.069,0,0,1,.119.135.4.4,0,0,1,.044.051,3.05,3.05,0,0,1,.292.443,2.383,2.383,0,0,1,.111.236,2.938,2.938,0,0,1,.179.556c.043.2.078.393.1.585a5.709,5.709,0,0,1,.046,1C774.438,812.207,754.174,814.409,744.235,814.54Z",
    transform: "translate(-720.527 -741.799)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M711.434,818.719s-15.89-3.1-16.582,3.613c-.744,7.217,18.2,1.813,18.2,1.813s-7.305,1.6-6.958-2.5C706.427,817.681,711.434,818.719,711.434,818.719Z",
    transform: "translate(-694.831 -752.413)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M753.712,729c-3.118,4.379-.329,16.366-.329,16.366H732.448c.578-.82,2.208-11.152-1.463-16.847-5.925-9.188.459-16.331.459-16.331l8.706-1.583.556-2.772.381-1.909.089-.444h3.916l.142.833.307,1.815.453,2.677,8,1.737S760.853,718.966,753.712,729Z",
    transform: "translate(-713.498 -689.963)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M755.259,746.493a8.66,8.66,0,0,1-2.587,4.281c-3.617,3.714-10.984,3.548-16.037,4.9l-.527-2.693s9.022-2.545,10.962-5.709a3.057,3.057,0,0,0,.407-.933c.658-3.154-2.993-7.1-2.993-7.1l-.388-18.309s12.264,18.663,11.165,25.56Zm-25.29,6.533.092,1.791a.169.169,0,0,0-.019-.326c-4.5-.93-11.906.357-15.51-2.7a10.606,10.606,0,0,1-3.72-6.005c-1.1-6.9,10.863-25.2,10.863-25.2l-.442,18.286s-3.651,3.944-2.994,7.1a5.1,5.1,0,0,0,1.208,2.009C722.149,751.146,729.969,753.026,729.969,753.026Z",
    transform: "translate(-703.661 -698.346)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M750.45,728.33l-.007-.02c-2.3-4.725-5.027-8.659-6.924-9.365l-.017-.016-.089-.02a1.7,1.7,0,0,0-.3-.066l-7.611-1.655c-.76,1.633-5.509,1.748-5.843-.2l-8.711,1.586-.005.006c-2.384.787-6.426,7.182-9,13.658a.313.313,0,0,0-.012.037c-1.812,4.563-2.887,9.16-2.131,11.849a12.989,12.989,0,0,0,4.013,6.055l1.518-1.262,3.776-3.141c-.646-.755-1.411-1.246-1.525-1.807-.492-2.358,2.614-5.057,4.212-6.27h0c1.906,5.752.652,13.353.16,14.051h20.935s-2.223-9.55-.48-14.714c1.62,1.527,4.761,4.845,4.269,7.2a2.932,2.932,0,0,1-.369.957l4.065,2.634,1.55,1.007a.41.41,0,0,0,.524-.065,9.177,9.177,0,0,0,2.273-4.277C755.389,740.865,753.231,734.032,750.45,728.33Z",
    transform: "translate(-703.003 -696.35)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M754.472,810.616c1.261,5.381-13.065,2.773-15.723,2.244-.272-.054-.421-.085-.421-.085s-2.076.1-5.242.084H732.9a108.391,108.391,0,0,1-17.49-1.362c-7.475-1.332-13.89-3.914-13.879-8.866a.1.1,0,0,0,0-.027,5.7,5.7,0,0,1,.038-.615.023.023,0,0,0,0-.011c.026-.215.062-.432.108-.655a2.958,2.958,0,0,1,.178-.567,2.46,2.46,0,0,1,.111-.242c.044-.082.091-.162.141-.24a0,0,0,0,0,0,0c.046-.072.1-.142.15-.21a.407.407,0,0,1,.045-.053,1.138,1.138,0,0,1,.12-.139c.048-.051.1-.1.147-.15,0-.006.006-.009.009-.007a5.037,5.037,0,0,1,2.382-1.125c6.834-1.52,22.344,3.8,30.207,6.775l.34.13c2.7,1.023,4.418,1.744,4.418,1.744s.529-.1,1.387-.218c.01,0,.021,0,.034,0,3.438-.463,12.014-1.122,13.124,3.6Z",
    transform: "translate(-698.55 -741.489)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M735.837,804.251l-.327.992-2.424,7.367-.335,1.015a93.48,93.48,0,0,1-15.724-1.421l0,0c-8.144-1.509-15.519-4.444-15.491-9.821a.1.1,0,0,0,0-.027c0-.2.016-.409.038-.615a.023.023,0,0,0,0-.011c.026-.215.062-.433.108-.655a2.959,2.959,0,0,1,.178-.567,2.465,2.465,0,0,1,.111-.242c.044-.082.091-.162.141-.24a0,0,0,0,0,0,0c.046-.072.1-.142.15-.21a.4.4,0,0,1,.045-.053,1.153,1.153,0,0,1,.12-.139c.048-.051.1-.1.147-.15,0-.006.006-.009.009-.007a5.347,5.347,0,0,1,2.5-1.228c7.027-1.715,22.908,3.047,30.755,6.017Z",
    transform: "translate(-698.55 -741.24)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M785.828,817.42s16.157-3.3,16.919,3.54c.818,7.344-18.519,2-18.519,2s7.064,1.338,6.676-2.832c-.375-4.035-5.076-2.708-5.076-2.708Z",
    transform: "translate(-744.446 -751.649)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M755.5,755.044H729.168c-.925,0-1.533.941-1.36,2.075l2.6,17.112a1.607,1.607,0,0,0,1.528,1.347h20.8a1.607,1.607,0,0,0,1.528-1.347l2.6-17.112c.173-1.134-.435-2.075-1.36-2.075Z",
    transform: "translate(-713.117 -717.471)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M747.326,681.368a6.694,6.694,0,0,1-.592-7.828s.769,1.392,1.68,1.008c0,0,.048-3.265,6.675-3.938,0,0-.48,1.3-.24,1.633,2.185-.96,4.305,1.424,6.435.528,0,0,.588,3.783-1.861,5.992a3.373,3.373,0,0,1-.492,2.6C758.067,682.665,747.326,681.368,747.326,681.368Z",
    transform: "translate(-723.084 -670.611)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M749.561,687.421s-1.431-1.4-1.566-.042c-.16,1.608,1.754,2.8,1.754,2.8s.467,4.971,4.661,4.971c4.16,0,4.856-4.99,4.856-4.99s2.188-.6,1.724-2.486c-.22-.9-1.361.02-1.361.02v-2.361s-1.166.593-3.418-.372c-1.63-.7-2.211-1.671-3.6-1.616C751.02,683.412,749.5,685.154,749.561,687.421Z",
    transform: "translate(-724.332 -677.679)",
    fill: "#ffd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(642.07 133.286)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 98.806,
    cy: 23.347,
    rx: 98.806,
    ry: 23.347,
    transform: "translate(0 176.091)",
    fill: "#dde1f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631-2",
    "data-name": "Group 4631",
    transform: "translate(23.376 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M741.969,795.11s-31.545,4.666-31.007,4.354S768.7,828.486,768.7,828.486l56.356-25.252L797.11,795.11Z",
    transform: "translate(-692.057 -649.189)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    d: "M755.976,837.433c-.159,0-.32,0-.472.006h-.292c-8.026.091-13.265-.108-13.265-.108s-.384.087-1.088.231c-6.861,1.423-43.857,8.472-40.7-5.469,2.764-12.241,24.959-10.72,33.861-9.6a.372.372,0,0,1,.088.012c2.221.283,3.59.534,3.59.534s4.416-1.9,11.387-4.6c.287-.114.583-.232.876-.344,22.961-8.911,71.25-25.8,83.75-15.652v.007c.137.105.273.223.4.341.008-.006.02,0,.024.019.132.126.258.256.383.386a2.825,2.825,0,0,1,.314.356,1.043,1.043,0,0,1,.117.135,8.033,8.033,0,0,1,.77,1.168,6.311,6.311,0,0,1,.292.622,7.707,7.707,0,0,1,.471,1.464c.112.523.206,1.035.269,1.54a15.082,15.082,0,0,1,.121,2.638c-1,22.511-54.725,25.965-80.889,26.311Z",
    transform: "translate(-693.948 -648.469)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111-2",
    "data-name": "Path 111",
    d: "M749.309,840.13l-.888-2.618-.386-1.142a.016.016,0,0,1,0-.014L742,818.515l-.866-2.558c22.983-8.921,72.769-24.044,85.483-13.459l0,.007a4.3,4.3,0,0,1,.4.362c.008-.006.02,0,.024.019.133.125.258.256.383.385a2.824,2.824,0,0,1,.314.357,1.028,1.028,0,0,1,.117.135,8.023,8.023,0,0,1,.77,1.167,6.238,6.238,0,0,1,.292.622,7.736,7.736,0,0,1,.471,1.464c.113.523.206,1.035.268,1.54a15.023,15.023,0,0,1,.121,2.638C828.857,833.985,775.486,839.786,749.309,840.13Z",
    transform: "translate(-686.865 -648.541)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    d: "M738.562,819.889s-41.851-8.177-43.674,9.515c-1.958,19.007,47.929,4.776,47.929,4.776s-19.24,4.21-18.326-6.581C725.373,817.157,738.562,819.889,738.562,819.889Z",
    transform: "translate(-694.831 -645.251)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113-2",
    "data-name": "Path 113",
    d: "M794.959,767.426c-8.213,11.534-.867,43.106-.867,43.106H738.955c1.524-2.16,5.817-29.372-3.854-44.373-15.6-24.2,1.208-43.014,1.208-43.014l22.931-4.169,1.464-7.3,1-5.028.236-1.169h10.313l.374,2.193.808,4.78,1.194,7.051,21.079,4.576S813.767,741,794.959,767.426Z",
    transform: "translate(-689.044 -664.611)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114",
    d: "M828,788.825c-.573,3.572-3.09,7.447-6.813,11.276-9.526,9.783-28.929,9.346-42.24,12.9l-1.389-7.092s23.761-6.7,28.871-15.038a8.05,8.05,0,0,0,1.071-2.457c1.732-8.306-7.884-18.692-7.884-18.692L798.589,721.5s32.3,49.156,29.407,67.322Zm-66.61,17.207.241,4.716a.446.446,0,0,0-.05-.858c-11.862-2.451-31.357.94-40.85-7.121-5.849-4.974-9.043-11.1-9.8-15.817-2.894-18.166,28.612-66.368,28.612-66.368l-1.164,48.161s-9.617,10.387-7.885,18.692a13.44,13.44,0,0,0,3.181,5.29C740.789,801.08,761.385,806.032,761.385,806.032Z",
    transform: "translate(-692.094 -662.013)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116",
    d: "M840.967,830.707c3.321,14.174-34.41,7.3-41.411,5.909-.716-.142-1.11-.225-1.11-.225s-5.468.256-13.807.222h-.488c-12.107-.063-30.018-.724-46.065-3.587-19.688-3.507-36.585-10.31-36.554-23.351a.275.275,0,0,0,0-.07,14.985,14.985,0,0,1,.1-1.621.063.063,0,0,0,0-.028c.068-.566.163-1.139.283-1.724a7.8,7.8,0,0,1,.468-1.494,6.444,6.444,0,0,1,.293-.637c.116-.217.239-.427.372-.633a.007.007,0,0,0,.006-.008c.122-.19.258-.375.4-.553a1.063,1.063,0,0,1,.118-.14,3,3,0,0,1,.317-.366c.127-.134.253-.267.388-.395,0-.016.015-.025.024-.019a13.268,13.268,0,0,1,6.273-2.962c18-4,58.852,10,79.56,17.843.3.113.6.23.894.343,7.121,2.7,11.635,4.594,11.635,4.594s1.392-.267,3.652-.574c.027-.006.055,0,.089-.012,9.055-1.22,31.642-2.955,34.566,9.488Z",
    transform: "translate(-693.678 -648.637)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117",
    d: "M791.885,814.675l-.862,2.613-6.384,19.4-.883,2.673a246.222,246.222,0,0,1-41.416-3.742l-.008-.006c-21.451-3.973-40.876-11.7-40.8-25.866a.277.277,0,0,0,0-.071c0-.532.042-1.077.1-1.621a.061.061,0,0,0,0-.028c.068-.566.163-1.139.283-1.724a7.8,7.8,0,0,1,.468-1.494,6.466,6.466,0,0,1,.293-.636c.116-.217.239-.427.372-.633a.007.007,0,0,0,.006-.008c.122-.19.258-.375.4-.553a1.088,1.088,0,0,1,.118-.139,3.037,3.037,0,0,1,.317-.366c.127-.133.253-.267.388-.395,0-.015.015-.025.024-.019a14.081,14.081,0,0,1,6.582-3.235c18.507-4.516,60.337,8.026,81,15.848Z",
    transform: "translate(-693.678 -648.714)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118-2",
    "data-name": "Path 118",
    d: "M788.442,818.717S831,810.038,833,828.042c2.155,19.343-48.775,5.266-48.775,5.266s18.605,3.523,17.585-7.459C800.824,815.222,788.442,818.717,788.442,818.717Z",
    transform: "translate(-679.45 -645.488)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120-2",
    "data-name": "Path 120",
    d: "M749.92,698.945a17.63,17.63,0,0,1-1.56-20.617s2.024,3.668,4.426,2.655c0,0,.126-8.6,17.581-10.372,0,0-1.266,3.414-.633,4.3,5.755-2.529,11.339,3.752,16.948,1.391,0,0,1.55,9.965-4.9,15.783a8.884,8.884,0,0,1-1.3,6.858C778.21,702.36,749.92,698.945,749.92,698.945Z",
    transform: "translate(-686.072 -670.611)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121",
    d: "M752.135,694.08s-3.769-3.687-4.124-.109c-.421,4.235,4.62,7.384,4.62,7.384s1.229,13.093,12.275,13.093c10.958,0,12.79-13.143,12.79-13.143s5.763-1.572,4.541-6.548c-.58-2.363-3.584.052-3.584.052v-6.219s-3.072,1.561-9-.981c-4.293-1.843-5.823-4.4-9.491-4.256-4.182.167-8.188,4.755-8.024,10.728Z",
    transform: "translate(-685.685 -668.42)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M817.264,746.86l-.019-.053c-6.067-12.445-13.24-22.806-18.236-24.665l-.045-.043-.234-.052a4.465,4.465,0,0,0-.795-.174l-20.046-4.359c-2,4.3-14.51,4.6-15.39-.527l-22.943,4.176-.014.017c-6.279,2.072-16.925,18.917-23.7,35.973a.788.788,0,0,0-.031.1c-4.773,12.019-7.6,24.125-5.613,31.21a34.214,34.214,0,0,0,10.569,15.947l4-3.323,9.946-8.273c-1.7-1.989-3.716-3.282-4.018-4.759-1.3-6.21,6.883-13.319,11.093-16.513h0c5.02,15.15,1.718,35.17.422,37.007h55.141s-5.855-25.154-1.263-38.755c4.266,4.023,12.54,12.762,11.244,18.969a7.716,7.716,0,0,1-.972,2.521l10.707,6.939,4.082,2.652a1.079,1.079,0,0,0,1.379-.171,24.171,24.171,0,0,0,5.987-11.266C830.275,779.875,824.591,761.88,817.264,746.86Z",
    transform: "translate(-692.572 -663.068)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119-2",
    "data-name": "Path 119",
    d: "M800.782,755.044H731.438c-2.437,0-4.036,2.478-3.583,5.465l6.835,45.07a4.232,4.232,0,0,0,4.024,3.547h54.791a4.232,4.232,0,0,0,4.023-3.547l6.835-45.07c.455-2.988-1.146-5.465-3.582-5.465Z",
    transform: "translate(-689.162 -656.083)",
    fill: "url(#linear-gradient-10)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpScreen);
export default __webpack_public_path__ + "static/media/otpScreen.9540e446494ff3de8d4d25169e1cd6ed.svg";
export { ForwardRef as ReactComponent };